import { put, takeEvery, takeLatest } from 'redux-saga/effects';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import financialServices from './services';
import financialActions from './actions';
import financialTypes from './types';

function* getFinancialBalance(action) {
	try {
		let response = yield sagaCallService(
			financialServices.balance,
			action,
			action.payload
		);
		yield put(financialActions.balanceSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, financialActions.balanceFailure);
	}
}

function* getFinancialBalanceDetails(action) {
	try {
		let response = yield sagaCallService(
			financialServices.balance_details,
			action,
			action.payload
		);
		yield put(financialActions.balanceDetailsSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			financialActions.balanceDetailsFailure
		);
	}
}

function* getFinancialPaymentVerification(action) {
	try {
		let response = yield sagaCallService(
			financialServices.verify_payment,
			action,
			action.payload
		);
		yield put(financialActions.verifyPaymentSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, financialActions.verifyPaymentFailure);
	}
}

function* requestPayment(action) {
	try {
		let response = yield sagaCallService(
			financialServices.payment_request,
			action,
			action.payload
		);
		yield put(financialActions.requestPaymentSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			financialActions.requestPaymentFailure
		);
	}
}

function* getpaymentHistoryList(action) {
	try {
		let response = yield sagaCallService(
			financialServices.payment_history_list,
			action,
			action.payload
		);
		yield put(
			financialActions.paymentHistoryListSuccess({
				response: response.data,
				requestAction: action.payload,
			})
		);
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			financialActions.paymentHistoryListFailure
		);
	}
}

function* getPaymentRequestDtails(action) {
	try {
		let response = yield sagaCallService(
			financialServices.payment_request_details,
			action,
			action.payload
		);
		yield put(financialActions.paymentRequestDetailsSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			financialActions.paymentRequestDetailsFailure
		);
	}
}

function* getTransactions(action) {
	try {
		let response = yield sagaCallService(
			financialServices.transactions,
			action,
			action.payload
		);
		yield put(financialActions.transactionsSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, financialActions.transactionsFailure);
	}
}

const financialSagas = [
	takeLatest(financialTypes.BALANCE.REQUEST, getFinancialBalance),
	takeLatest(
		financialTypes.BALANCE_DETAILS.REQUEST,
		getFinancialBalanceDetails
	),
	takeLatest(
		financialTypes.VERIFY_PAYMENT.REQUEST,
		getFinancialPaymentVerification
	),
	takeLatest(financialTypes.PAYMENT_REQUEST.REQUEST, requestPayment),
	takeEvery(financialTypes.PAYMENT_HISTORY_LIST.REQUEST, getpaymentHistoryList),
	takeLatest(
		financialTypes.PAYMENT_REQUEST_DETAILS.REQUEST,
		getPaymentRequestDtails
	),
	takeLatest(financialTypes.TRANSACTIONS.REQUEST, getTransactions),
];

export default financialSagas;
